<template>
  <div>
    <section class="content">
      <div class="row" v-if="!paramError">
        <form @submit.prevent="checkIndividuals">
          <div class="col-md-12">
            <div class="box box-info">
              <div class="box-body">
                <!-- calendar group -->

                  <div class="row entrada">
                      <label for="rut" class="control-label col-lg-4 col-md-3 col-sm-3 col-xs-3 text-right " >CUIT</label>
                      <div class="col-lg-7 col-md-9 col-sm-9 col-xs-9 ">
                        <masked-input :mask="rutMask" :guide="false" class="form-control " type="text"  name="rut" id="rut" placeholder="CUIT" v-model="rut" required/>
                      </div>
                  </div>

                  <div class="row entrada">
                      <label for="rut" class="control-label col-lg-4 col-md-3 col-sm-3 col-xs-3  text-right" >Tipo Documento</label>
                      <div class="col-lg-7 col-md-9 col-sm-9 col-xs-9">
                        <select name="typeDoc" id="typeDoc" class="form-control " v-model="typeDoc" required>
                          <option value="factura">FACTURA</option>
                        </select>
                      </div>
                  </div>

                  <div class="row entrada">
                      <label for="rut" class="control-label col-lg-4 col-md-3 col-sm-3 col-xs-3  text-right" >Nro Factura</label>
                      <div class="col-lg-7 col-md-9 col-sm-9 col-xs-9">
                          <!-- <masked-input :mask="invoiceMask" :guide="false" class="form-control " type="text" name="numberInvoice" id="numberInvoice" placeholder="Nro Factura" v-model="numberInvoice" required /> -->
                        <masked-input :mask="invoiceMask" :guide="false" class="form-control " type="text" name="numberInvoice" id="numberInvoice" placeholder="Nro Factura" v-model="numberInvoice" required />
                      </div>
                  </div>

                  <div class="row entrada">
                      <label for="rut" class="control-label col-lg-4 col-md-3 col-sm-3 col-xs-3 text-right" >Fecha Emision</label>
                      <div class="col-lg-7 col-md-9 col-sm-9 col-xs-9">
                        <div class="input-group">
                          <span class="input-group-addon">
                            <i class="fa fa-fw fa-calendar"></i>
                          </span>
                          <input class="form-control" type="date" format="DDMMYYYY" name="dateEmission" id="dateEmission" v-model="dateEmission" required ></input>
                        </div>
                      </div>
                  </div>

                  <div class="row entrada">
                      <label for="rut" class="control-label col-lg-4 col-md-3 col-sm-3 col-xs-3 text-right" >Monto</label>
                      <div class="col-lg-7 col-md-9 col-sm-9 col-xs-9">
                      <input class="form-control" name="amount" id="amount" placeholder="Monto" v-model="amount" required />
                      </div>
                  </div>

                  <div class="row entrada">
                    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
                          <button type="submit" v-bind:class="'btn btn-primary btn-lg ' + loading">Consulta</button>
                    </div>
                  </div>

                <!-- /input-group -->
              </div>
              <!-- /.box-body -->
            </div>
          </div>
        </form>
      </div>
      <div class="row">
        <div class="col-md-12 text-center" v-if="response" >
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-yellow"><i class="ion ion-android-alert"></i></span>
                <div class="info-box-content">
                  <span class="info-box-text">Advertencia</span>
                  <span class="info-box-info">{{response}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
      <div class="row" v-if="invoices">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12" if="invoices">
            <div class="info-box ">
              <span class="info-box-icon bg-green"><i class="ion ion-android-checkmark-circle"></i></span>
              <div class="info-box-content">
                <span class="info-box-text">Información</span>
                <span class="info-box-info">Fecha de Pago : {{invoices.datePayment}}</span><br>
                <span class="info-box-info">Estado        : {{invoices.invoiceStatus}}</span>
              </div>
              <!-- /.info-box-content -->
            </div>
          <!-- /.info-box -->
        </div>
      </div>
      <div class="row" v-if="paramError">
        <div class="col-md-12 text-center">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
              <div class="info-box ">
                <span class="info-box-icon bg-red"><i class="ion ion-android-alert"></i></span>
                <div class="info-box-content">
                  <span class="info-box-text">Advertencia</span>
                  <span class="info-box-info">{{paramError}}</span>
                </div>
                <!-- /.info-box-content -->
              </div>
            <!-- /.info-box -->
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
require('moment')
// import datepicker from 'vue-date-picker'
import api from '../../api'
import MaskedInput from 'vue-text-mask'

export default {
  name: 'Individual',
  components: {
    // datepicker,
    MaskedInput
  },
  data (router) {
    return {
      section: 'Individual',
      loading: '',
      rut: '',
      typeDoc: 'factura',
      numberInvoice: '',
      amount: '',
      invoices: null,
      dateEmission: '',
      response: null,
      paramError: null,
      rutMask: this.$store.state.rutMask,
      invoiceMask: this.$store.state.invoiceMask
    }
  },
  computed: {
    datetime () {
      return new Date()
    }
  },
  beforeMount () {
    api.request('get', 'api/checkParam?id=CIF-001')
      .then(response => {
        var data = response.data

        if (data.error) {
          this.paramError = data.error
        }
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    checkIndividuals () {
      console.log(dateEmission)
      const {rut, typeDoc, numberInvoice, dateEmission, amount} = this

      this.toggleLoading()
      this.resetResponse()
      this.$store.commit('TOGGLE_LOADING')

      /* Making API call to authenticate a user */
      api.request('GET', 'api/listByAnonymous' + '?rut=' + rut + '&typeDoc=' + typeDoc + '&numberInvoice=' + numberInvoice + '&dateEmission=' + dateEmission + '&amount=' + amount)
        .then(response => {
          this.toggleLoading()
          this.invoices = null

          var data = response.data
          /* Checking if error object was returned from the server */
          if (response.data.error) {
            var errorName = response.data.error.name
            if (errorName) {
              if (errorName === 'InvalidArgumentError') {
                this.response = 'Los datos suministrados son incorrectos.'
              } else if (errorName === 'NotFoundError') {
                this.response = 'La factura no se encuentra.'
              } else {
                this.response = errorName
              }
            } else {
              this.response = data.error
            }

            return
          } else {
            if (data) {
              this.invoices = data
            }
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          this.invoices = null
          console.log(error)

          this.response = 'Error al conectarse con el servidor, contacte al administrador.'
          this.toggleLoading()
        })
    },
    toggleLoading () {
      this.loading = (this.loading === '') ? 'cargando' : ''
    },
    resetResponse () {
      this.response = ''
    }
  }
}
</script>

<style>
.datetime-picker input {
  height: 4em !important;
}


.entrada {
  padding: 2px 0px 5px 0px;

}
</style>



// WEBPACK FOOTER //
// Individual.vue?d01dd6f0